import { render, staticRenderFns } from "./btnCalculCoSimple.vue?vue&type=template&id=3da0ea8d&scoped=true"
import script from "./btnCalculCoSimple.vue?vue&type=script&lang=js"
export * from "./btnCalculCoSimple.vue?vue&type=script&lang=js"
import style0 from "./btnCalculCoSimple.vue?vue&type=style&index=0&id=3da0ea8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0ea8d",
  null
  
)

export default component.exports